// Info
export { commandList } from '../lib/command-list';



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/src/index.js
 **/